'use client';

import AppImage from '@/components/ui/AppImage';

const IntroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/95 via-neuro-primary/95 to-primary/90 py-24 pt-32 overflow-hidden min-h-[70vh]">
      {/* Semi-transparent background image */}
      <div className="absolute inset-0 z-0">
        <AppImage
          src="/assets/images/ChatGPT_Image_Dec_31_2025_11_06_31_PM-1767202892837.png"
          alt="Newborn baby in medical incubator with neural network brain monitoring visualization showing glowing brain connections and blue medical environment"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/60 via-neuro-primary/60 to-primary/50" />
      </div>

      {/* Brain Wave Animation Overlay */}
      <div className="absolute inset-0 z-[5] pointer-events-none overflow-hidden">
        {/* Multiple wave layers for depth */}
        <svg className="absolute w-[200%] h-full animate-brainwave" style={{ left: '-100%' }} viewBox="0 0 1200 400" preserveAspectRatio="none">
          <path
            d="M0,200 Q50,180 100,200 T200,200 Q250,220 300,200 T400,200 Q450,190 500,200 T600,200 Q650,210 700,200 T800,200 Q850,195 900,200 T1000,200 Q1050,205 1100,200 T1200,200"
            fill="none"
            stroke="rgba(107, 155, 209, 0.4)"
            strokeWidth="2"
            className="animate-brainwave-pulse"
          />
        </svg>
        
        <svg className="absolute w-[200%] h-full animate-brainwave" style={{ left: '-100%', animationDelay: '2s', animationDuration: '40s' }} viewBox="0 0 1200 400" preserveAspectRatio="none">
          <path
            d="M0,220 Q60,200 120,220 T240,220 Q300,235 360,220 T480,220 Q540,210 600,220 T720,220 Q780,225 840,220 T960,220 Q1020,215 1080,220 T1200,220"
            fill="none"
            stroke="rgba(255, 255, 255, 0.25)"
            strokeWidth="1.5"
            className="animate-brainwave-pulse"
            style={{ animationDelay: '2.5s' }}
          />
        </svg>

        <svg className="absolute w-[200%] h-full animate-brainwave" style={{ left: '-100%', animationDelay: '4s', animationDuration: '48s' }} viewBox="0 0 1200 400" preserveAspectRatio="none">
          <path
            d="M0,180 Q70,165 140,180 T280,180 Q350,190 420,180 T560,180 Q630,175 700,180 T840,180 Q910,185 980,180 T1120,180 L1200,180"
            fill="none"
            stroke="rgba(107, 155, 209, 0.3)"
            strokeWidth="1.5"
            className="animate-brainwave-pulse"
            style={{ animationDelay: '1s' }}
          />
        </svg>
      </div>

      {/* Content */}
      <div className="max-w-[1200px] mx-auto px-6 relative z-10">
        <div className="text-center">
          <h2 className="text-4xl lg:text-5xl font-bold font-heading mb-6 leading-tight text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
            Protecting the most Precious Brains - From Day One
          </h2>
          
          <p className="text-xl lg:text-2xl leading-relaxed max-w-4xl mx-auto text-white drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)]">
            When every second counts, we bring smart, cutting edge, life saving technology to protect the most vulnerable brains.
          </p>
        </div>
      </div>

      {/* Gradient transition to next section */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-primary z-10" />
    </section>
  );
};

export default IntroSection;